"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AD_ACCOUNT_NO_ACCESS_MESSAGE = exports.AD_ACCOUNT_NO_ACCESS = void 0;
exports.AD_ACCOUNT_NO_ACCESS = 'AD_ACCOUNT_NO_ACCESS';
exports.AD_ACCOUNT_NO_ACCESS_MESSAGE = 'Exclusion failed, no access to ad account';
